import { z } from "zod";
import { ModuleDefinitionFieldSchema } from "../form-bindings/index.js";
import { InstancesSchema } from "../form-engine/instances.js";
// A session template as a note is written from it: its name, and its modules
// in the order the note shows them, each with what it is for, what its answers
// are about, and the fields it holds, custom and bound alike.
export const SessionTemplateDefinitionModuleSchema = z.object({
    id: z.guid(),
    name: z.string(),
    description: z.string(),
    instances: InstancesSchema,
    fields: ModuleDefinitionFieldSchema.array(),
});
export const SessionTemplateDefinitionSchema = z.object({
    id: z.guid(),
    name: z.string(),
    modules: z.array(SessionTemplateDefinitionModuleSchema),
    // The template's version these modules are, which a note started from it
    // pins (ADR-032 P).
    version: z.int().positive(),
});
